import type { WebhookEventFormatsItem } from 'api';

import { WEBHOOK_FORMAT_LABELS } from './AddWebhookModal/constants';
import type { ToggleMode } from './constants';

const webhookNoun = (n: number) => (n === 1 ? 'webhook' : 'webhooks');

export const webhookFormatLabel = (format: string): string =>
  WEBHOOK_FORMAT_LABELS[format as WebhookEventFormatsItem] ?? format;

export const toggleWebhookTitle = (mode: ToggleMode, n: number) => {
  const verb = mode === 'activate' ? 'Activate' : 'Deactivate';
  return n === 1 ? `${verb} webhook` : `${verb} ${n} ${webhookNoun(n)}`;
};

export const toggleWebhookConfirmLabel = (mode: ToggleMode, n: number) => {
  const verb = mode === 'activate' ? 'Activate' : 'Deactivate';
  return n > 1 ? `${verb} all` : verb;
};

export const toggleWebhookSuccessMessage = (mode: ToggleMode, n: number) => {
  const verb = mode === 'activate' ? 'activated' : 'deactivated';
  return n === 1 ? `Webhook ${verb}` : `${n} webhooks ${verb}`;
};

export const bulkEditInfoMessage = (n: number) =>
  `Editing ${n} ${webhookNoun(n)}. Empty fields will keep their current values — only filled fields will be updated.`;

export const bulkEditSuccessMessage = (n: number) =>
  n === 1 ? 'Webhook updated' : `${n} webhooks updated`;

export const bulkPartialFailureMessage = (
  succeeded: number,
  failed: number,
  verb: string
) =>
  `${succeeded} ${webhookNoun(succeeded)} ${verb}, ${failed} could not be ${verb}`;

export const bulkAllFailedMessage = (verb: string) =>
  `No webhooks could be ${verb}`;

export const reactivateWebhookConflictTitle = (n: number) =>
  n === 1 ? 'Reactivate webhook' : `Reactivate ${n} ${webhookNoun(n)}`;

export const reactivateWebhookSuccessMessage = (n: number) =>
  n === 1 ? 'Webhook reactivated' : `${n} ${webhookNoun(n)} reactivated`;

export const activateBlockedByKeyIntro = (count: number) =>
  count === 1
    ? 'This webhook uses a disabled key and will not be activated. Enable the key under Developers → Authentication first:'
    : `These ${count} webhooks use a disabled key and will not be activated. Enable the key under Developers → Authentication first:`;

export const activateBlockedTitle = (count: number) =>
  count === 1 ? 'Cannot activate webhook' : 'Cannot activate webhooks';
